export const DOSSIER_LESSONS_PT = [
  {
    id: 'dossier-1',
    numero: 1,
    titre: "Identificar os documentos necessários",
    sousTitre: "O que preciso exactamente?",
    contexte: "Pediu-lhe um processo completo. Como saber o que é necessário e reunir tudo correctamente?",
    explication: [
      "**Leia a lista com atenção**: comece por ler toda a lista de documentos necessários antes de procurar qualquer documento.",
      "**Documentos comuns**: comprovativo de morada (factura com menos de 3 meses), documento de identidade, RIB, recibo de vencimento, aviso de imposto.",
      "**Comprovativo de morada**: factura de electricidade, gás, telefone ou recibo de renda — deve ter menos de 3 meses.",
      "**RIB**: documento com os dados da sua conta bancária — obtenha-o na aplicação do banco ou no balcão.",
      "**Verifique as datas**: alguns documentos têm validade (menos de 3 meses, menos de 6 meses). Verifique sempre antes de enviar.",
    ],
    question: "O comprovativo de morada não deve ter mais de...",
    options: [
      { id: 'a', text: "3 meses", correct: true },
      { id: 'b', text: "6 meses", correct: false },
      { id: 'c', text: "1 ano", correct: false },
    ],
    explication_reponse: "O comprovativo de morada deve ter menos de 3 meses. Uma factura da EDF ou recibo de renda — verifique a data antes de enviar.",
  },
  {
    id: 'dossier-2',
    numero: 2,
    titre: "Digitalizar os seus documentos",
    sousTitre: "Uma cópia digital nítida",
    contexte: "Os documentos estão prontos em papel. Agora precisa de uma versão digital para enviar electronicamente. Veja a forma correcta.",
    explication: [
      "**Aplicações de digitalização gratuitas**: Adobe Scan, CamScanner ou Microsoft Lens — transformam uma foto do telemóvel num PDF nítido.",
      "**Iluminação**: coloque o documento numa superfície plana e iluminada. Evite sombras e reflexos. A luz natural é excelente.",
      "**Documento plano**: não segure o papel no ar — coloque-o completamente plano para uma imagem nítida.",
      "**Qualidade e tamanho**: todas as informações devem ser legíveis. Tamanho aceitável: entre 500 kilobytes e 2 megabytes.",
      "**Verifique o resultado**: antes de enviar, abra o ficheiro e confirme que tudo está nítido — textos, números e datas.",
    ],
    question: "Qual a melhor forma de fotografar um documento com o telemóvel para obter uma imagem nítida?",
    options: [
      { id: 'a', text: "Documento plano, boa iluminação, aplicação de digitalização", correct: true },
      { id: 'b', text: "Documento na mão com flash da câmara", correct: false },
      { id: 'c', text: "Não importa o método desde que a foto seja tirada", correct: false },
    ],
    explication_reponse: "O documento plano com luz natural e uma aplicação de digitalização dá os melhores resultados. A aplicação corrige a distorção e melhora o contraste automaticamente.",
  },
  {
    id: 'dossier-3',
    numero: 3,
    titre: "Nomear e organizar os ficheiros",
    sousTitre: "Para não perder nenhum documento",
    contexte: "Tem dezenas de ficheiros chamados 'scan001', 'foto.jpg'... Como organizá-los para encontrá-los imediatamente?",
    explication: [
      "**Convenção de nomes**: adopte um formato fixo — 'TipoDocumento_Nome_Data.pdf'. Por exemplo: 'RIB_Silva_2026.pdf'.",
      "**Pastas por entidade**: crie uma pasta para cada entidade — pasta CAF, pasta Impostos, pasta Saúde.",
      "**Cópias de segurança na nuvem**: Google Drive ou iCloud — os seus documentos acessíveis em qualquer dispositivo e em segurança mesmo que o telemóvel se perca.",
      "**Não apague documentos antigos**: o aviso de imposto de 2020 pode ser necessário em 2026. Guarde os documentos administrativos 5 a 10 anos.",
      "**Juntar o processo**: ao enviar um processo completo, pode juntar vários PDFs num só em ilovepdf.com — mais fácil de enviar.",
    ],
    question: "Qual o melhor nome para um ficheiro RIB que quer enviar?",
    options: [
      { id: 'a', text: "RIB_NomeApelido_2026.pdf", correct: true },
      { id: 'b', text: "scan001.jpg", correct: false },
      { id: 'c', text: "documento.pdf", correct: false },
    ],
    explication_reponse: "Um nome claro facilita ao funcionário identificar e classificar o documento. 'scan001' ou 'documento' não dão qualquer informação e podem atrasar o processo.",
  },
  {
    id: 'dossier-4',
    numero: 4,
    titre: "Enviar o processo e acompanhá-lo",
    sousTitre: "Até à confirmação",
    contexte: "O processo está pronto. Agora é necessário enviá-lo e confirmar a recepção — e o que fazer se não for tratado?",
    explication: [
      "**Envio electrónico**: no site oficial da entidade, na secção 'O meu processo' ou 'Enviar documento'. Email como alternativa.",
      "**Comprovativo de envio**: guarde sempre o comprovativo de envio — data e hora são importantes para provar que enviou dentro do prazo.",
      "**Captura de ecrã**: após o envio num site, tire uma captura de ecrã da confirmação. No telemóvel: botão de volume + botão de energia.",
      "**Se o processo não for tratado**: aguarde 15 dias úteis e depois acompanhe — ligando para o número da entidade ou por mensagem electrónica.",
      "**Guarde uma cópia de tudo**: cópia dos documentos enviados + comprovativo de envio + toda a correspondência posterior.",
    ],
    question: "Enviou o processo electronicamente. O que deve guardar como prova?",
    options: [
      { id: 'a', text: "Captura de ecrã ou comprovativo de confirmação com data", correct: true },
      { id: 'b', text: "Nada — o envio electrónico não precisa de prova", correct: false },
      { id: 'c', text: "Apenas o nome do funcionário que recebeu", correct: false },
    ],
    explication_reponse: "A data e hora são muito importantes — provam que enviou antes do prazo limite. Guarde a captura de ecrã numa pasta específica para correspondência administrativa.",
  },
];
